// sync with otk …/driver-license-country.constants.ts
/** Canonical selector values stored on the order. Copied from otk — do not import. */
export const DRIVER_LICENSE_COUNTRY_RUSSIA = 'Россия'
export const DRIVER_LICENSE_COUNTRY_BELARUS = 'Беларусь'
export const DRIVER_LICENSE_COUNTRY_KAZAKHSTAN = 'Казахстан'
export const DRIVER_LICENSE_COUNTRY_KYRGYZSTAN = 'Киргизия'
export const DRIVER_LICENSE_COUNTRY_ABKHAZIA = 'Абхазия'
export const DRIVER_LICENSE_COUNTRY_SOUTH_OSSETIA = 'Южная Осетия'
export const DRIVER_LICENSE_COUNTRY_OTHER = 'Другая'

export const DRIVER_LICENSE_COUNTRY_FOREIGN_ALLOWED = [
  DRIVER_LICENSE_COUNTRY_BELARUS,
  DRIVER_LICENSE_COUNTRY_KAZAKHSTAN,
  DRIVER_LICENSE_COUNTRY_KYRGYZSTAN,
  DRIVER_LICENSE_COUNTRY_ABKHAZIA,
  DRIVER_LICENSE_COUNTRY_SOUTH_OSSETIA,
]

export const DRIVER_LICENSE_COUNTRY_SELECTOR_VALUES = [
  DRIVER_LICENSE_COUNTRY_RUSSIA,
  ...DRIVER_LICENSE_COUNTRY_FOREIGN_ALLOWED,
  DRIVER_LICENSE_COUNTRY_OTHER,
]
